import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface DeleteGroupModalProps {
  anyAutomaticExpense: boolean
  onSubmit: () => void
  onClose: () => void
}

const DeleteGroupModal = ({ anyAutomaticExpense, onSubmit, onClose }: DeleteGroupModalProps) => {
  const handleSubmit = () => {
    onClose()
    onSubmit()
  }

  return (
    <Modal
      title={
        anyAutomaticExpense
          ? i18n.t('expenses_v2.group_detail.modals.delete.with_automatic_expenses.title')
          : i18n.t('expenses_v2.group_detail.modals.delete.title')
      }
      description={
        anyAutomaticExpense
          ? i18n.t('expenses_v2.group_detail.modals.delete.with_automatic_expenses.description')
          : i18n.t('expenses_v2.group_detail.modals.delete.description')
      }
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('expenses_v2.buttons.cancel')}
          </Button>
          <Button onClick={handleSubmit}>{i18n.t('expenses_v2.buttons.delete')}</Button>
        </>
      }
      onClose={onClose}
      illustration="alert"
    />
  )
}

export default DeleteGroupModal
